import React, {Component} from 'react';
import {
    Table,
    List,
    Header,
    Label,
    Icon,
    Image,
    Grid, Button, Modal
} from 'semantic-ui-react';
import {FormattedNumber} from 'react-intl';
import {withRouter} from 'react-router-dom';
import localDB from "../../data/localDB";
import DynamicTable from "../../components/extras/DynamicTable";
import SaleData from "../../data/SaleData";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/lib/connect/connect";
import LoadingModal from "../../components/extras/LoadingModal";
import SimpleTable from "../../components/extras/SimpleTable";
const c = require("../../constants");

class Total extends Component {
    render() {
        return <React.Fragment>
            <Header as='h3' textAlign='center' style={{margin:'0px'}}>
                Total Venta: $<FormattedNumber
                value={this.props.total.total_sale}
                currency="USD"
                maximumFractionDigits={0}
                minimumFractionDigits={0}
            />
            </Header>
            {
                this.props.total.balance !== 0 ? <Header as='h3' textAlign='center' style={{margin:'0px'}} color='orange'>
                    Saldo: $<FormattedNumber
                    value={this.props.total.balance}
                    currency="USD"
                    maximumFractionDigits={0}
                    minimumFractionDigits={0}
                />
                </Header>:null
            }
        </React.Fragment>
    }
}

class SaleState extends Component {
    render() {
        let state = c.SALE_STATE.find((unit) => unit.key===this.props.state)
        return <React.Fragment>
            <Label color={state.color}>
                <Icon name={state.icon}/> {state.text}
            </Label>
        </React.Fragment>
    }
}

class Client extends Component{

    render(){
        if(this.props.client){
            return <List divided>
                <List.Item>
                    <List.Content>
                        <List.Header as='h3'>{this.props.client.full_name}</List.Header>
                    </List.Content>
                </List.Item>
                <List.Item>
                    <List.Icon name='marker'/>
                    <List.Content>{this.props.client.address ? this.props.client.address:'---'}</List.Content>
                </List.Item>
                <List.Item>
                    <List.Icon name='phone'/>
                    <List.Content>{this.props.client.phone ? this.props.client.phone:'---'}</List.Content>
                </List.Item>
            </List>
        }else{
            return <Label color='orange'>Sin Asignar</Label>
        }

    }
}

class FormatOrderNumber extends Component{
    render() {
        return <Table.Cell>{`No. ${this.props.billing_number}`}</Table.Cell>
    }
}

class PreviousStatus extends Component{
    render(){
        let ALL_STATUS = [ ...c.REPAIR_SHOP_STATUS]
        let previous_status = ALL_STATUS.find((option) => option.key === this.props.previous_status)

        return <Label color={previous_status.color}>
            <Icon name={previous_status.icon}/> {previous_status.text}
        </Label>
    }
}

class CurrentStatus extends Component{
    render(){
        let ALL_STATUS = [ ...c.REPAIR_SHOP_STATUS]
        let current_status = ALL_STATUS.find((option) => option.key === this.props.status)

        return <Label color={current_status.color}>
            <Icon name={current_status.icon}/> {current_status.text}
        </Label>
    }
}

class SaleItem extends Component{
    constructor(props) {
        super(props);
        this.state = {
            modal_history: false,
            table_history: {
                headers: ['Fecha y Hora', 'Usuario', 'Estado Anterior', 'Estado Actual', 'Observaciones'],
                title: 'Historial',
                url: `sales/status-history/${this.props.sale_id}`,
                values: ['id', 'date', 'user', 'previous_status', 'status', 'observations'],
                datetime_fields: ['date'],
                child_fields: [{user:'full_name'}],
                id: 'table_history',
                has_actions: false,
                component_fields:[{
                    previous_status: PreviousStatus,
                    status: CurrentStatus
                }],
            },
        }
        this.toggleModalHistory = this.toggleModalHistory.bind(this)
    }

    toggleModalHistory = () => {
        this.setState({modal_history: !this.state.modal_history})
    }

    render() {
        let product_name = this.props.item.product.name;
        let ALL_STATUS = [ ...c.REPAIR_SHOP_STATUS]
        let status = ALL_STATUS.find((option) => option.key === this.props.delivery_state)
        if(this.props.item.product.is_special){
            product_name = this.props.item.details.model
        }
        return (
            <List.Item key={this.props.item.id}>
                <Image avatar>
                    <Label circular color='orange'>{this.props.item.quantity}</Label>
                </Image>
                <List.Content>
                    <List.Header as='h3'>{product_name}</List.Header>
                    <List.Description>{this.props.item.observation}{this.props.item.product.is_special ? <React.Fragment>
                        <br/>
                        <Label as='a' color={status.color} onClick={() => this.toggleModalHistory()}>
                            <Icon name={status.icon}/> {status.text}
                        </Label>
                    </React.Fragment>:null}</List.Description>
                </List.Content>
                <Modal size='small' dimmer='inverted' open={this.state.modal_history} onClose={this.toggleModalHistory}>
                    <Modal.Header>
                        Historial
                    </Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <SimpleTable {...this.state.table_history} />
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.toggleModalHistory} icon='x' labelPosition='left' content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
            </List.Item>
        );
    }
}
class SaleItems extends Component{

    render() {
        let delivery_state = this.props.delivery_state
        let id = this.props.id

        return <List divided relaxed>
             { this.props.items.length >0 ?
                 this.props.items.map(function (item) {
                     return (
                         <SaleItem item={item} delivery_state={delivery_state} sale_id={id} />
                     )
                 }):<List.Item>
                     <List.Content>
                         <List.Description>
                             <Label style={{width:'100%'}}>
                                 <Icon name='alarm' /> No se han agregado productos
                             </Label>
                         </List.Description>
                     </List.Content>
                 </List.Item>
             }
        </List>;
    }
}

class CounterSale extends Component {

    buttonAddSale = () => {
        return <div style={{margin:6}}>
            <Button fluid content='Nueva Venta' onClick={()=>this.addSale()} primary={true} loading={this.state.sending}/>
        </div>;
    }

    constructor() {
        super();

        let other_actions_components =[
            this.buttonAddSale
        ]

        this.state = {
            table_balances: {
                headers: ['Nº', 'Cliente', 'Productos', 'Total Venta', 'Estado', 'Acciones'],
                name: 'Venta',
                title: 'Ventas',
                has_actions: true,
                navigate: true,
                pagination: true,
                url: 'counter-sales',
                values: ['id', 'billing_number', 'client', 'total', 'items', 'state'],
                id: 'table_balances',
                money_fields: [],
                component_fields: [{
                    client: Client,
                    billing_number: FormatOrderNumber,
                    items: SaleItems,
                    total: Total,
                    state: SaleState
                }],
                other_actions_components: other_actions_components,
            },
            total: 0,
            loading: true,
            show_loading_modal: false
        };

        this.goSale = this.goSale.bind(this);
        this.buttonAddSale = this.buttonAddSale.bind(this);
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'navigate'){
            localDB.saveSaleStorage(response.data, 'sale');
            this.props.history.push(`/sale/view/${response.data.billing_number}`);
        }
    };

    goSale = (sale) => {
        localDB.saveSaleStorage(sale, 'sale');
        this.props.history.push(`/sale/view/${sale.billing_number}`);
    };

    addSale = () => {
        this.setState({show_loading_modal: true});

        let data = {
            order: {
                quantity: 1,
                waiter: null,
                type: 4,
                client: null,
                state: 1
            },
        };
        SaleData.open(data, (res) => {
            if (res !== null && res.hasOwnProperty('id')) {
                SaleData.get(res.id, (res) =>{
                    if(res.hasOwnProperty('id')){
                        this.goSale(res);
                    }
                    else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                });
            } else {
                this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
            }
            this.setState({show_loading_modal: false});
        });
    };

    render() {
        return (
            <Grid stackable>
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <DynamicTable {...this.state.table_balances} callbackDynamicTable={this.callbackDynamicTable} />
                    </Grid.Column>
                </Grid.Row>
                <LoadingModal show={this.state.show_loading_modal}/>
            </Grid>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        showToast(toast) {
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(withRouter(CounterSale))



// WEBPACK FOOTER //
// ./src/containers/sale/CounterSale.js